export default {
  "provider.dashboard": "Dashboard",
  "provider.products": "My tours",
  "provider.calendar": "Calendar",
  "provider.revenue": "Revenue",
  "provider.bookings": "Bookings",
  "provider.reviews": "Reviews",
  "provider.revenueToday": "Today",
  "provider.revenueWeek": "This week",
  "provider.revenueMonth": "This month",
  "provider.totalBookings": "Total bookings",
  "provider.pendingBookings": "Pending",
  "provider.confirmedBookings": "Confirmed",
  "provider.avgRating": "Average rating",
  "provider.newBooking": "New booking",
  "provider.noBookings": "No recent bookings",
  "provider.viewAll": "View all",
  "provider.mpCtaBadge": "Coming soon",
  "provider.mpCtaTitle": "Connect your Mercado Pago",
  "provider.mpCtaBody": "Soon you'll be able to receive your booking payments directly in your own Mercado Pago account, instantly. You get paid directly and only pay us the agreed commission.",
  "provider.mpCtaButton": "Connect Mercado Pago",
  "provider.mpCtaBodyLive": "Receive your booking payments straight into your own Mercado Pago account, instantly. You collect directly and only pay us the agreed commission.",
  "provider.mpConnecting": "Connecting…",
  "provider.mpConnected": "Your Mercado Pago account is connected.",
  "provider.mpCancelled": "You cancelled the Mercado Pago connection. You can try again any time.",
  "provider.mpConnectedTitle": "Mercado Pago connected",
  "provider.mpConnectedBody": "Your booking payments arrive directly in your account. We only withhold the agreed commission.",
  "provider.mpAccount": "Account",
  "provider.mpDisconnect": "Disconnect",
  "provider.mpDisconnectConfirm": "Disconnect your Mercado Pago account? Payments for your next bookings will go back to being collected through the platform.",
  "provider.mpReconnectBadge": "Needs attention",
  "provider.mpReconnectTitle": "Reconnect your Mercado Pago",
  "provider.mpReconnectBody": "Your account authorisation is about to expire or is no longer valid. Reconnect it to keep receiving payments directly.",
  "provider.mpReconnectButton": "Reconnect Mercado Pago",
  "provider.mpErr_expired_link": "The connection link expired. Press \"Connect Mercado Pago\" again.",
  "provider.mpErr_exchange_failed": "Mercado Pago did not accept the connection. Try again; if it persists, contact us.",
  "provider.mpErr_account_already_linked": "That Mercado Pago account is already linked to another provider. If you were not asked for any details, Mercado Pago reused the session already open in this browser: sign out of mercadopago.com.mx, or open an incognito window, and try again with the provider's own account.",
  "provider.mpErr_not_configured": "Mercado Pago connection is not enabled on the platform yet.",
  "provider.mpErr_platform_account": "You authorised the platform's Mercado Pago account, not the provider's. Sign out of mercadopago.com.mx or use an incognito window, then try again signing in with the provider's account.",
  "provider.mpErr_unknown": "We could not complete the connection. Please try again.",
  "provider.mpCtaSoon": "Available soon",
  "provider.addTour": "New tour",
  "provider.editTour": "Edit",
  "provider.deleteTour": "Delete",
  "provider.tourName": "Tour name",
  "provider.category": "Category",
  "provider.price": "Price",
  "provider.status": "Status",
  "provider.active": "Active",
  "provider.paused": "Paused",
  "provider.draft": "Draft",
  "provider.save": "Save",
  "provider.cancel": "Cancel",
  "provider.description": "Description",
  "provider.duration": "Duration",
  "provider.maxGuests": "Max guests",
  "provider.languages": "Languages",
  "provider.images": "Images",
  "provider.uploadImage": "Upload image",
  "provider.included": "Included",
  "provider.notIncluded": "Not included",
  "provider.meetingPoint": "Meeting point",
  "provider.cancellation": "Cancellation policy",
  "provider.itinerary": "Itinerary",
  "provider.addStep": "Add step",
  "provider.time": "Time",
  "provider.stepTitle": "Title",
  "provider.stepDesc": "Description",
  "provider.sun": "Sun",
  "provider.mon": "Mon",
  "provider.tue": "Tue",
  "provider.wed": "Wed",
  "provider.thu": "Thu",
  "provider.fri": "Fri",
  "provider.sat": "Sat",
  "provider.availability": "Availability",
  "provider.blockDate": "Block date",
  "provider.unblockDate": "Unblock",
  "provider.booked": "Booked",
  "provider.available": "Available",
  "provider.blocked": "Blocked",
  "provider.rating": "Rating",
  "provider.activeTours": "Active tours",
  "provider.netTotal": "Net total",
  "provider.loading": "Loading…",
  "provider.noData": "No data yet",
  "provider.loadError": "Couldn't load the panel.",
  "provider.profileLoadError": "We couldn't load your company details. Please reload the page before editing.",
  "provider.profileSaveError": "We couldn't save your changes. Please try again.",
  "provider.companyNameRequired": "Company name is required.",
  "provider.colRef": "Ref",
  "provider.colClient": "Customer",
  "provider.colTour": "Tour",
  "provider.colDate": "Date",
  "provider.colTotal": "Total",
  "provider.colStatus": "Status",
  "provider.statusColumn": "Status",
  "provider.bookingsColumn": "Bookings",
  "provider.verifiedCustomer": "Verified customer",
  "provider.noReviewsYet": "You don't have reviews yet. Once your customers complete their tours they can leave one.",
  "provider.loadReviewsError": "Couldn't load your reviews.",
  "provider.reviewsApproved": "Approved reviews",
  "provider.reviewsTotal": "Total",
  "provider.reviewPending": "Pending",
  "provider.reviewRejected": "Rejected",
  "provider.bookingId": "ID",
  "provider.customer": "Customer",
  "provider.tour": "Tour",
  "provider.date": "Date",
  "provider.guestsColumn": "Guests",
  "provider.totalColumn": "Total",
  "provider.netColumn": "Net",
  "provider.noMatches": "No matches with the current filters.",
  "provider.topTours": "Top tours by revenue",
  "provider.monthlyBreakdown": "Monthly breakdown",
  "provider.period": "Period",
  "provider.gross": "Gross sales",
  "provider.commissionColumn": "Commission",
  "provider.net": "Net",
  "provider.bookingsCount": "bookings",
  "provider.revenueChart": "Revenue by month (last 12)",
  "provider.noRevenueYet": "No revenue to chart yet.",
  "provider.statusConfirmed": "Confirmed",
  "provider.statusPending": "Pending",
  "provider.statusCompleted": "Completed",
  "provider.statusCancelled": "Cancelled",
  "provider.archived": "Archived",
  "provider.archiveTour": "Archive",
  "provider.archiveConfirm": "Archive this tour? It will stop appearing in the catalog.",
  "provider.archiveError": "Couldn't archive the tour.",
  "provider.archivingEllipsis": "Archiving…",
  "provider.noProductsYet": "You don't have any tours published yet. Create the first one.",
  "provider.calTourLabel": "Tour:",
  "provider.calPrevMonth": "Previous month",
  "provider.calNextMonth": "Next month",
  "provider.calAvailable": "Available",
  "provider.calLimited": "Few slots left",
  "provider.calFull": "Full",
  "provider.calClosed": "Closed",
  "provider.calNotSet": "Not set",
  "provider.calToday": "Today",
  "provider.calConfigureTitle": "Configure availability",
  "provider.calCapacityLabel": "Total capacity",
  "provider.calCapacityHint": "Set to 0 to close that day. If bookings already exist, capacity cannot drop below the {{count}} already booked.",
  "provider.calStartTimeLabel": "Start time (optional)",
  "provider.calPriceOverrideLabel": "Special day price (MXN, optional)",
  "provider.calPriceOverridePlaceholder": "Use the tour's regular price",
  "provider.calCancel": "Cancel",
  "provider.calSave": "Save",
  "provider.calLoadToursError": "Couldn't load your tours.",
  "provider.calLoadAvailError": "Couldn't load availability.",
  "provider.calSaveError": "Couldn't save.",
  "provider.calCapacityValidation": "Capacity must be a number ≥ 0.",
  "provider.calAvailableCount": "{{count}} available",
  "provider.calBookedCount": "{{count}} booked",

  // Shared
  "provider.saving": "Saving…",
  "provider.savedShort": "Saved.",

  // Onboarding / document verification
  "provider.onb.title": "Provider verification",
  "provider.onb.desc": "Upload your documents so the team can verify your account. Accepts photos (JPG/PNG/WebP) or PDF.",
  "provider.onb.ine": "ID (INE)",
  "provider.onb.ineHint": "Valid official ID",
  "provider.onb.proof": "Proof of address",
  "provider.onb.proofHint": "No older than 3 months",
  "provider.onb.curp": "CURP",
  "provider.onb.curpHint": "Mexican population registry code",
  "provider.onb.acta": "Articles of incorporation",
  "provider.onb.actaHint": "Companies only (optional)",
  "provider.onb.verified": "Verified",
  "provider.onb.rejected": "Rejected",
  "provider.onb.pending": "Under review",
  "provider.onb.replace": "Replace",
  "provider.onb.uploadShort": "Upload",
  "provider.onb.uploading": "Uploading…",
  "provider.onb.delete": "Delete",
  "provider.onb.uploadError": "Could not upload the file.",
  "provider.onb.editCompany": "Edit company details →",

  // Notifications (feed)
  "provider.notif.all": "All",
  "provider.notif.unread": "Unread",
  "provider.notif.markAllRead": "Mark all read",
  "provider.notif.empty": "You have no notifications.",
  "provider.notif.justNow": "Just now",
  "provider.notif.minsAgo": "{{n}} min ago",
  "provider.notif.hoursAgo": "{{n}} h ago",
  "provider.notif.daysAgo": "{{n}} d ago",

  // Booking settings
  "provider.cfg.title": "Booking settings",
  "provider.cfg.desc": "Adjust how you accept bookings for your tours.",
  "provider.cfg.minDays": "Minimum advance booking (days)",
  "provider.cfg.minDaysHint": "Customers won't be able to book with less than this many days' notice. 0 = no minimum.",
  "provider.cfg.range": "Enter a number between 0 and 365.",
  "provider.cfg.saveError": "Could not save.",

  // EN parity: onboarding, company profile, earnings/payouts, settings, review replies
  "provider.autoConfirm": "Automatic confirmation",
  "provider.autoConfirmDesc": "Bookings are confirmed without manual review",
  "provider.back": "Back",
  "provider.bank": "Bank",
  "provider.bankAccount": "Bank account",
  "provider.bookingSettings": "Booking settings",
  "provider.commissionPaid": "Commission paid",
  "provider.companyAddress": "Tax address",
  "provider.companyName": "Company name",
  "provider.companyProfile": "Company profile",
  "provider.continue": "Continue",
  "provider.createFirstTour": "Create my first tour",
  "provider.earnings": "Earnings and payouts",
  "provider.emailBookings": "New bookings",
  "provider.emailBookingsDesc": "Receive an email when there's a new booking",
  "provider.emailPayments": "Payments received",
  "provider.emailPaymentsDesc": "Receive an email when a payment is processed",
  "provider.emailReviews": "New reviews",
  "provider.emailReviewsDesc": "Receive an email when someone leaves a review",
  "provider.hours": "hours",
  "provider.instantBooking": "Instant booking",
  "provider.instantBookingDesc": "Allow bookings without prior approval",
  "provider.language": "Language",
  "provider.minNotice": "Minimum notice",
  "provider.notifications": "Notifications",
  "provider.notificationSettings": "Notifications",
  "provider.onboardingComplete": "All set!",
  "provider.onboardingCompleteDesc": "You can now create your first tour and start receiving bookings.",
  "provider.onboardingDesc": "Complete these steps to start selling tours",
  "provider.pendingPayout": "Pending payout",
  "provider.replied": "Replied",
  "provider.reply": "Reply",
  "provider.replyPlaceholder": "Write your reply...",
  "provider.reviewsReceived": "Reviews received",
  "provider.sendReply": "Send reply",
  "provider.settings": "Settings",
  "provider.settlements": "Settlements",
  "provider.totalEarnings": "Total earnings",
  "provider.upload": "Upload",
  "provider.verification": "Verification",
  "provider.website": "Website",
  "provider.welcome": "Welcome!",

  // Sidebar / company profile
  "provider.company": "Company",
  "provider.verified": "Verified provider",
  "provider.suspended": "Account suspended",
  "provider.pendingVerification": "Pending verification",
  "provider.saved": "Saved",
  "provider.phone": "Phone",
  "provider.email": "Email",

  // Bookings
  "provider.all": "All",

  // Calendar (dynamic legend key)
  "provider.calNoConfig": "Not set",

  // Tour form (ProductForm)
  "provider.formSectionBasics": "Basics",
  "provider.formTitle": "Tour title",
  "provider.formCategory": "Category",
  "provider.formLocation": "Location",
  "provider.formDesc": "Description",
  "provider.formItinerary": "Itinerary",
  "provider.formItineraryHint": "One box per item. Time is optional.",
  "provider.formItineraryTime": "8:00",
  "provider.formItineraryStep": "Departure",
  "provider.formItineraryAdd": "Add step",
  "provider.formItineraryRemove": "Remove step",
  "provider.formMeetingPoint": "Meeting point",
  "provider.formDuration": "Duration",
  "provider.formDurationPlaceholder": "8 hours",
  "provider.formLanguages": "Languages",
  "provider.formSectionPricing": "Price and capacity",
  "provider.formPriceAdult": "Adult price (MXN)",
  "provider.formPriceChild": "Child price (optional)",
  "provider.formMaxGuests": "Maximum guests",
  "provider.formSectionMedia": "Images",
  "provider.formMediaHelp": "Upload images from your computer or paste URLs. The first one will be the cover. Max 5 MB per image (JPG, PNG, WebP).",
  "provider.formMediaUpload": "Upload from my computer",
  "provider.orPasteUrl": "Or paste a URL",
  "provider.formMediaAdd": "Add",
  "provider.formMediaEmpty": "No images yet.",
  "provider.formSectionPublish": "Publishing",
  "provider.statusActiveDesc": "Visible in the catalog and accepting bookings.",
  "provider.statusPausedDesc": "Hidden from the catalog. Existing bookings are not affected.",
  "provider.formCancel": "Cancel",
  "provider.formSave": "Save changes",
  "provider.formPublish": "Publish tour",
  "provider.uploading": "Uploading…",
  "provider.uploadError": "We couldn't upload the image.",
  "provider.required": "Required",
  "provider.descMin": "The description must be at least 20 characters.",
  "provider.priceInvalid": "Invalid price",
  "provider.maxGuestsMin": "At least 1",
  "provider.saveError": "We couldn't save. Please try again.",

  // Products (new / edit)
  "provider.backToProducts": "Back to products",
  "provider.tourNotFound": "Tour not found.",
};